import { ReactNode } from "react";
import clsx from "clsx";
import { TabsValue, useTabsContext } from "./TabsContext";

export type TabsPanelProps<T extends TabsValue = TabsValue> = {
  value: T;
  className?: string;
  children: ReactNode;
};

export const TabsPanel = <T extends TabsValue>({
  value: panelValue,
  className,
  children,
}: TabsPanelProps<T>) => {
  const { value, styles } = useTabsContext<T>();

  if (value !== panelValue) return null;

  return (
    <div
      id={`tab-panel-${panelValue}`}
      role="tabpanel"
      className={clsx(styles.panelClassName, className)}
    >
      {children}
    </div>
  );
};
